module.exports = __webpack_public_path__ + "img/cttcanarias-icon.ef251772.png";